
import { slide as MobileMenu } from "react-burger-menu";
import LoginView from "./LoginView"
import UsersView from "./UsersView";
import UserCreateView from "./UserCreateView";
import ContactsView from "./ContactsView";
import ContactCreateView from "./ContactCreateView";
import DonationView from "./DonationView";
import EventView from "./EventView";
import Home from "./Home";
import ModalChangePassword from "./ModalChangePassword";
import Mailbox from '../components/newsletter/Mailbox';
import SubscriptionsView from "./SubscriptionsView";
import { Banner, SideNav, SideNavCategory, SideNavItem, SideNavSection, IconButton, Chip} from "@airbus/components-react"
import { Lock } from "@airbus/icons/react";

import React from "react";
import {
    Flex,
    Header,
  } from "@airbus/components-react";

import { Person } from "@airbus/icons/react";

//CSS
import '../css/MobileMenu.css';
import '../css/header.css';


//MODELS IMPORT
import GlobalUser from "../models/User"; //get global instance

//EVENT BUS
import eventBus from "../eventBus/EventBus";
import EventCreateView from "./EventCreateView";




class MainView extends React.Component {

    constructor(){
        super();
        
        this.state = {
            user: GlobalUser,   //connected user
            selectedTab: null,  //tab selected by the user
            page:"home",        //sideNav Page
            name: "Home",
            windowWidth: window.innerWidth, //screen width 
            windowHeight: window.innerHeight, //screen height
            flag_changePassword: false,         //display Change Password Modal Box
            menuopen: false,
            notification: false,                //notification display
        }

        //Notifications properties
        this.notifVariant = null;
        this.notifMessage = null;
        this.notifDescription = null;

    }

    /**
     * Handle Window Height & Width
     */
    handleResize = (e) => {
        this.setState({ 
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight
        });

    };

    componentDidMount() {

        //Listener User get logged -> user is dispatched once logged in from loginForm
        //debugger;
        eventBus.on("user", (data) => {          
            this.setState({ user: GlobalUser }) //set state to refresh Main component
                       

        });

        window.addEventListener("resize", this.handleResize);

        
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.handleResize);
    }

    /**
     * RENDERING
     * @returns dom
     */
     render() { return(
        <div>
            
            {/* USER NOT LOGGED IN -> SHOW LOGIN VIEW */}
            {this.state.user.getUserId() === null ?
                <LoginView/>
            :null}

            {/* USER IS LOGGED IN -> SHOW TABS*/}
            {this.state.user.getUserId() !== null ?
                
                <Header appName={this.state.name} id="sajm_header">
                    
                    <Flex direction="row" style={{alignItems: "center", flexFlow:"wrap", gap:'5px'}}>
                        <Chip style={{marginLeft: '5px'}}
                            label={this.state.user.getUserFirstName()}
                            icon={<Lock/>}
                        />
                        <Chip style={{marginLeft: '5px'}}
                            label={"Droits: "+this.state.user.getUserRole()}
                        />
                        
                    </Flex>
                    <IconButton variant="ghost" onClick={this.onChangePasswordClick}>
                            <Person />
                    </IconButton>
                    
                </Header>
                

            :null}

            {this.state.user.getUserId() !== null && this.state.notification &&
                <div style={{position:"fixed", width:this.state.windowWidth-100, zIndex:1000, marginLeft:'70px'}}>
                    <Banner variant={this.notifVariant} autoHideDuration={3000}  onClose={() => this.toggleNotif(false)}>
                        <div>
                            <p>{this.notifMessage}</p>
                        {this.notifDescription !== null &&
                            <p>{this.notifDescription}</p>
                        }
                        </div>
                    </Banner>
                </div>
            }
            

            
            

            
            {this.state.user.getUserId() !== null ?
            <Flex style={{ overflow: "hidden" }}>
            
            {/* SIDE NAVIGATION */}
            
            <MobileMenu isOpen={this.state.menuopen} onOpen={ ()=>this.setState({menuopen:true}) } onClose={ ()=>this.setState({menuopen:false}) }>
                <SideNav permanent theme="dark" aria-label="Main Navigation" style={{height:this.state.windowHeight - 128}}>
                <h2 style={{ paddingLeft: "1rem" }}>SAJM</h2>
                <SideNavSection>
                    <SideNavItem
                        selected={this.state.page === "home"}
                        onSelected={() => this.setState({page:"home", name:"Home", menuopen:false})}
                    >
                        Accueil
                    </SideNavItem>
                    <SideNavCategory
                        label="Gestion des utilisateurs"
                        open={this.isInCategory(this.state.page, "users_mngt")}
                        selected={this.state.page === "users_mngt"}
                        onSelected={() => this.setState({page:"users_mngt", name:"Accès"})}
                    >
                        <SideNavItem
                            selected={this.state.page === "users_mngt/list"}
                            onSelected={() => this.setState({page:"users_mngt/list", name:"Liste des Accès", menuopen:false})}
                        >
                        Liste des utilisateurs
                        </SideNavItem>
                        <SideNavItem
                            selected={this.state.page === "users_mngt/add"}
                            onSelected={() => this.setState({page:"users_mngt/add", name:"Nouvel Accès", menuopen:false})}
                        >
                        Créer nouvel utilisateur
                        </SideNavItem>
                    </SideNavCategory>
                    <SideNavCategory
                        label="Gestion des contacts"
                        open={this.isInCategory(this.state.page, "contacts_mngt")}
                        selected={this.state.page === "contacts_mngt"}
                        onSelected={() => this.setState({page:"contacts_mngt", name:"Contacts"})}
                    >
                        <SideNavItem
                            selected={this.state.page === "contacts_mngt/list"}
                            onSelected={() => this.setState({page:"contacts_mngt/list", name:"Liste des Contacts", menuopen:false})}
                        >
                        Liste des contacts
                        </SideNavItem>
                        <SideNavItem
                            selected={this.state.page === "contacts_mngt/add"}
                            onSelected={() => this.setState({page:"contacts_mngt/add", name:"Nouveau contact", menuopen:false})}
                        >
                        Créer nouveau contact
                        </SideNavItem>
                        
                        <SideNavItem
                            selected={this.state.page === "subscriptions/get"}
                            onSelected={() => this.setState({page:"subscriptions/get", name:"Abonnements", menuopen:false})}
                        >
                        Abonnements
                        </SideNavItem>
                    </SideNavCategory>
                    <SideNavItem
                        selected={this.state.page === "donation/list"}
                        onSelected={() => this.setState({page:"donation/list", name:"Abonnements", menuopen:false})}
                    >
                        Gestion des dons
                    </SideNavItem>
                    <SideNavCategory
                        label="Gestion des Evénements"
                        open={this.isInCategory(this.state.page, "event")}
                        selected={this.state.page === "event"}
                        onSelected={() => this.setState({page:"event", name:"Evénements"})}
                    >
                        <SideNavItem
                            selected={this.state.page === "event/list"}
                            onSelected={() => this.setState({page:"event/list", name:"Evénements", menuopen:false})}
                        >
                            Liste des Evénements
                        </SideNavItem>
                        <SideNavItem
                            selected={this.state.page === "event/add"}
                            onSelected={() => this.setState({page:"event/add", name:"Nouvel événement", menuopen:false})}
                        >
                            Créer un événement
                        </SideNavItem>
                    </SideNavCategory>
                    
                    <SideNavItem
                        selected={this.state.page === "sendmail"}
                        onSelected={() => this.setState({page:"sendmail", name:"Diffusion", menuopen:false})}
                    >
                        Envoyer Mail
                    </SideNavItem>
                </SideNavSection>
                </SideNav>
            </MobileMenu>
            
            <main style={{ padding: "0.25rem 2rem", overflowY: "auto", width:this.state.windowWidth }} >
                
                {/* CALL USER LIST COMPONENT*/}
                {this.state.page === 'home' && <Home/>} 
                
                {/* CALL USER LIST COMPONENT*/}
                {this.state.page === 'users_mngt/list' && <UsersView notificationHandler={this.toggleNotif}/>} 

                {/* CALL USER ADD COMPONENT*/}
                {this.state.page === 'users_mngt/add' && <UserCreateView notificationHandler={this.toggleNotif}/>} 

                {/* CALL CONTACT LIST COMPONENT*/}
                {this.state.page === 'contacts_mngt/list' && <ContactsView notificationHandler={this.toggleNotif}/>} 

                {/* CALL CONTACT ADD COMPONENT*/}
                {this.state.page === 'contacts_mngt/add' && <ContactCreateView notificationHandler={this.toggleNotif}/>} 

                {/* CALL DONATION COMPONENT*/}
                {this.state.page === 'donation/list' && <DonationView notificationHandler={this.toggleNotif}/>} 

                {/* CALL EVENT COMPONENT*/}
                {this.state.page === 'event/list' ? <EventView notificationHandler={this.toggleNotif}/>:null} 

                {/* CALL EVENT ADD COMPONENT*/}
                {this.state.page === 'event/add' ? <EventCreateView notificationHandler={this.toggleNotif}/>:null} 

                {/* CALL SEND MAIL*/}
                {this.state.page === 'sendmail' ? <Mailbox notificationHandler={this.toggleNotif}/>:null} 

                {/* CALL SUBSCRRIPTIONS*/}
                {this.state.page === 'subscriptions/get' ? <SubscriptionsView/>:null} 

                

                {/* CHANGE PASSWORD*/}
                <ModalChangePassword/>

            </main>
            </Flex>

            :null}
        </div>
    )}

    
    /**
     * FUNCTIONS
     */

     isInCategory = (page, category) => {
        return page.indexOf(category) >= 0;
     }

     /**
      * EVENTS
      */

      onChangePasswordClick = () =>{

            eventBus.dispatch("changePassword", { message: {
                title: "Modifier mon mot de passe",
                open: true,
                user_id: this.state.user.user_id 
                } 
            });
      }


      //fire / close notification
      toggleNotif = (val, notificationObject) => {
        
        if(!val){
            this.notifVariant=null;
            this.notifMessage=null;
            this.notifDescription=null;
        }else{
            this.notifVariant=notificationObject.notifVariant;
            this.notifMessage=notificationObject.notifMessage;
            this.notifDescription=notificationObject.notifDescription;
        }

        this.setState({
            notification: val
        });

        
      }


}

export default MainView;